import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	wrapper: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		gap: token('space.050'),
		justifyContent: 'flex-end',
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type Props = {
	onDismiss: () => Promise<void>;
	onApplyUpdates: () => Promise<void>;
	isDisabled?: boolean;
	allActionsApplied?: boolean;
	isBulkActioning?: boolean;
};

export const CardGroupFooter = ({
	onDismiss,
	onApplyUpdates,
	isDisabled = false,
	allActionsApplied = false,
	isBulkActioning = false,
}: Props): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (allActionsApplied) {
		return null;
	}

	return (
		<Flex
			xcss={styles.wrapper}
			testId="update-work-item-fields-action-renderer.ui.card-group-footer"
		>
			{/* If we are applying or dismissing all updates via a bulk action button, we show a spinner as all actions are executed */}
			{isBulkActioning ? (
				<Spinner interactionName="load" />
			) : (
				<>
					<Button appearance="subtle" onClick={onDismiss} isDisabled={isDisabled}>
						{formatMessage(messages.dismissButton)}
					</Button>
					<Button onClick={onApplyUpdates} isDisabled={isDisabled}>
						{formatMessage(messages.acceptAllButton)}
					</Button>
				</>
			)}
		</Flex>
	);
};
